(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results-common/assets/javascripts/parsers/parse-payout.js') >= 0) return;  svs.modules.push('/components/numbergames/results-common/assets/javascripts/parsers/parse-payout.js');

'use strict';

let format;
if (svs.isServer) {
  const trinidadCore = require('trinidad-core').core;
  format = trinidadCore.components.require('utils', 'format').api;
} else {
  format = svs.utils.format;
}
function parseLottoPayout(_ref) {
  let {
    distribution,
    millionRain
  } = _ref;
  const dromvinsten = distribution.find(_ref2 => {
    let {
      name
    } = _ref2;
    return name === 'Drömvinsten';
  });
  let dromvinstPayout;
  if (dromvinsten && dromvinsten.winners) {
    dromvinstPayout = dromvinsten;
    distribution = [...distribution.filter(payout => payout.name !== 'Drömvinsten')];
    const dist = distribution.find(_ref3 => {
      let {
        name
      } = _ref3;
      return name === '7 rätt';
    });
    dist.winners -= dromvinstPayout.winners;
    dromvinstPayout.amount = format.Currency(parseInt(dromvinstPayout.amount, 10) + parseInt(dist.amount, 10));
    for (let i = 0, len = distribution.length; i < len; i++) {
      const dist = distribution[i];
      if (millionRain && Array.isArray(millionRain.distribution)) {
        const million = millionRain.distribution.find(_ref4 => {
          let {
            name
          } = _ref4;
          return name === dist.name;
        });
        if (million) {
          dist.name += ', ej Joker';
          if (million.winners) {
            dist.winners -= million.winners;
            million.amount = format.Currency(parseInt(million.amount, 10) + parseInt(dist.amount, 10));
          }
        }
      }
      if (!dist.winners) {
        dist.amount = 0;
      }
    }
  }
  return {
    distribution,
    dromvinstPayout,
    millionRain
  };
}
function parseInternationalDistribution(_ref5, _ref6) {
  let {
    distribution
  } = _ref5;
  let {
    distribution: iDistribution
  } = _ref6;
  if (Array.isArray(iDistribution)) {
    for (let i = 0, len = iDistribution.length; i < len; i++) {
      distribution[i].iWinners = iDistribution[i].winners;
      if (distribution[i].winners === 0 && distribution[i].iWinners === 0) {
        distribution[i].amount = 'Jackpot';
      }
    }
  }
  return distribution;
}
if (svs.isServer) {
  module.exports = {
    parseLottoPayout,
    parseInternationalDistribution
  };
} else {
  svs.numbergames.results_common.parsers.payout = {
    parseLottoPayout,
    parseInternationalDistribution
  };
}

 })(window);